import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccessLinksService } from 'ldt-identity-service-api';
import { NotificationService } from '../shared/notification-service/notification.service';
import { Log } from '../logger.service';
import { AuthService } from '../auth/service/auth.service';
import { PeopleReportService } from '../people/report-service.service';
import { CompanyInfoService } from '../shared/company-search/company-info-service.service';
import { PeopleChatService } from '../core/services/people-chat.service';

const VALID_AL_URLS = [
  '/insights',
  '/people/explore',
  '/people/search',
  '/workforce',
  '/workforce/insights',
  '/chat',
];
@Component({
  selector: 'app-access-links',
  templateUrl: './access-links.component.html',
  styleUrls: ['./access-links.component.scss'],
  standalone: false,
})
export class AccessLinksComponent {
  constructor(
    private route: ActivatedRoute,
    private accessLinkService: AccessLinksService,
    private router: Router,
    private notify: NotificationService,
    private authService: AuthService,
    private reportService: PeopleReportService,
    private companyInfoService: CompanyInfoService,
    private peopleChatService: PeopleChatService
  ) {
    this.route.params.subscribe((params) => {
      const token = params['token'];
      if (!token) {
        this.router.navigate(['/']);
      }

      // get the token from the params and then look it up in the api service
      this.accessLinkService.getAccessLinkByToken(token).subscribe({
        next: (accessLink) => {
          Log.d('AccessLinksComponent constructor accessLink', accessLink);
          // backwards compatibility with new insights path
          let page = accessLink.redirect_url;
          if (page === '/workforce' || page === '/workforce/insights') {
            page = '/insights';
          }

          // This is a public link to workforce, with a non-logged in user, so we're going
          // to seed the cache from the AL data and send them to WF
          if (VALID_AL_URLS.includes(page) && !this.authService.isLoggedInValue) {
            this.authService.setPalMode(true);
            this.reportService.setCache(accessLink.config?.dataCache || {});
            this.companyInfoService.setCache(accessLink.config?.companyCache || []);
          }

          // For shared chats: seed the thread into the chat service cache and
          // navigate to /chat?threadId=<seeded-id> so the page picks it up natively.
          if (page === '/chat' && accessLink.config?.messages) {
            const threadId = this.peopleChatService.seedSharedThread({
              messages: accessLink.config.messages,
              company_lookups: accessLink.config.company_lookups,
              created_at: accessLink.config.created_at,
            });
            this.router.navigate([page], {
              queryParams: { threadId },
              state: { al_config: accessLink.config, al_created_at: accessLink.created_at },
            });
            return;
          }

          this.router.navigateByUrl(page, {
            state: { al_config: accessLink.config, al_created_at: accessLink.created_at },
          });
        },
        error: () => {
          this.notify.error('Invalid or private access link: ' + token);
          this.router.navigate(['/']);
        },
      });
    });
  }
}
